import queryKeys from '@/constants/queryKeys';
import { myOrganizationActiveContractGet } from '@/services/api/requests/organization';
import { useQuery } from '@tanstack/react-query';

const useGetOrganizationActiveContract = (userId?: string) => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.organization.activeContract, userId],
    queryFn: async () => {
      const response = await myOrganizationActiveContractGet();

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useGetOrganizationActiveContract;
